import { z } from 'zod/v4';
import { createDefinitionSchema } from '../../utils/helpers';

const spanFilterInput = z.object({
  type: z.enum(['Variable', 'Static']),
  value: z.string().optional(),
});

const spanFilter = z.object({
  service: spanFilterInput,
  operation: spanFilterInput,
});

export const serviceTopologyPanelDefintionSchema = createDefinitionSchema(
  'ChronoServiceTopology',
  z.object({
    spanFilters: z.array(spanFilter),
  })
);
